export default "__VITE_ASSET__DPjZapNZ__"